/**
 * Colour per tag, tuned to hold contrast on Nocturne's dark ground.
 *
 * These replace the raw CSS keywords the tags used to take literally
 * (`backgroundColor: "red"`), which is also what forced the old special case
 * where `yellow` needed a hardcoded green border to be visible at all — every
 * hue here carries its own readable border.
 */
export const TAG_COLORS: Record<Tag, { swatch: string; ring: string }> = {
  red: { swatch: "var(--tag-red)", ring: "rgba(255, 138, 138, 0.45)" },
  orange: { swatch: "var(--tag-orange)", ring: "rgba(255, 176, 103, 0.45)" },
  yellow: { swatch: "var(--tag-yellow)", ring: "rgba(242, 208, 107, 0.45)" },
  green: { swatch: "var(--tag-green)", ring: "rgba(111, 214, 165, 0.45)" },
  blue: { swatch: "var(--tag-blue)", ring: "rgba(127, 180, 255, 0.45)" },
  purple: { swatch: "var(--tag-purple)", ring: "rgba(201, 155, 255, 0.45)" },
};

/** Fallback for a tag with no entry above, e.g. one added server-side. */
export const UNKNOWN_TAG_COLOR = {
  swatch: "var(--ink-2)",
  ring: "var(--rule-strong)",
};
